export const MAX_PRICE = 300000;

export const DEFAULT_FILTERS = {
  search: "",
  metalType: "",
  grade: "",
  state: "",
  certification: "",
  maxDelivery: "",
  priceRange: [0, MAX_PRICE],
};

const PARAM_KEYS = { search: "search", metalType: "metal_type", grade: "grade", state: "state", certification: "certification", maxDelivery: "max_delivery_days" };

export function buildProductParams(filters, sortBy, sortOrder, page) {
  const params = new URLSearchParams();
  Object.entries(PARAM_KEYS).forEach(([key, param]) => { if (filters[key]) params.append(param, filters[key]); });
  if (filters.priceRange[0] > 0) params.append("min_price", filters.priceRange[0]);
  if (filters.priceRange[1] < MAX_PRICE) params.append("max_price", filters.priceRange[1]);
  params.append("sort_by", sortBy);
  params.append("sort_order", sortOrder);
  params.append("page", page);
  params.append("page_size", "12");
  return params;
}

export function countActiveFilters(f) {
  const basic = [f.metalType, f.grade, f.state, f.certification, f.maxDelivery].filter(Boolean).length;
  return basic + (f.priceRange[0] > 0 || f.priceRange[1] < MAX_PRICE ? 1 : 0);
}
